import { Empresa } from '@/shared/interfaces/erp/administration/empresas.interface';

export interface LoginDataResp {
  user_data: UserLogin;
  token: string;
  token_drive: string;
  token_consulta: string;

  ///* active session
  ip?: string;
  os?: string;

  ///* groups and permissions
  groups: string[];
  permissions: string[];
}

export interface UserLogin {
  user_id?: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  last_login_ip: string;
  last_login_date: string;
  empresa_data?: Empresa;
}

export const LOGIN_ERRORS = {
  wrongPassword: {
    allowedAttempts: 3,
    showMsgAttempt: 2,
  },
};

export interface LoginResponse {
  token: string;
  token_drive: string;
  id?: number;
  profile: ProfileLogin;
  permisos: string[];
  modulos: string[];
  email: string;
  username: string;
  mfa_setup_pendiente?: boolean;
  mfa_grace_until?: string | null;
}

export interface ProfileLogin {
  id: number
  bio: null
  intentos_fallidos: number
  ip_login: string
  os_login: string
  razon_social: null
  identificacion: null
  tipo_identificacion: string
  nombre: null
  apellido: null
  color: string
  canales_venta_adicionales?: string[]
  canales: string[]

  ///* fk
  rol: string;
  user: number;
  empresa: null;
  area: null;
  departamento: string;
  departamento_nombre: string | null;
  canal_venta: string | null;
  email?: string;
  username: string;
  user_id?: number;
}
